import cx from 'classnames';
import { useState } from 'react';

import { IconPlayArrow } from '../../../../../design-system/components/icons/PlayArrow';
import { Ratio, RATIO } from '../../../../../design-system/components/ratio/Ratio';
import { Typography } from '../../../../../design-system/components/typography/Typography';
import { HomePageDocument } from '../../../../../resources/homePageDocument/domain/types/homePageDocument';
import { HomeIconButton } from '../../IconButton/IconButton';

import style from './AgencyCard.module.css';

type AgencyCardProps = {
    className?: string;
    agency: HomePageDocument['agencies'][number];
    onClick: (agency: AgencyCardProps['agency']) => void;
};

const PICTURE_RATIO = RATIO['5/8'];

export function AgencyCard({ className, agency, onClick }: AgencyCardProps) {
    const [isHovered, setIsHovered] = useState(false);

    const { agencyName, agencyDestination, agencyPoster } = agency;

    return (
        <div
            className={cx(style.card, className)}
            onClick={() => {
                onClick(agency);
            }}
            onMouseEnter={() => {
                setIsHovered(true);
            }}
            onMouseLeave={() => {
                setIsHovered(false);
            }}
            onFocus={() => {
                setIsHovered(true);
            }}
            onBlur={() => {
                setIsHovered(false);
            }}
        >
            <Ratio ratio={PICTURE_RATIO} className={style.pictureWrapper}>
                <img
                    className={style.picture}
                    alt={agencyName}
                    src={agencyPoster.card_cover.url}
                    srcSet={`${agencyPoster.card_cover_retina.url} 2x`}
                    loading="lazy"
                    sizes="260px"
                />

                <div className={style.content}>
                    <Typography scale="primary-body-bold" className={style.agencyName}>
                        {agencyName}
                    </Typography>
                    <Typography scale="primary-xs-regular" className={style.destination}>
                        {agencyDestination}
                    </Typography>
                </div>
                <HomeIconButton
                    className={style.playVideoButton}
                    Icon={IconPlayArrow}
                    isHovered={isHovered}
                />
            </Ratio>
        </div>
    );
}

AgencyCard.PICTURE_RATIO = PICTURE_RATIO;
